import axios from "axios";

export const makePayment = async (paymentInformation, createdOder) => {
  const expireMonth = paymentInformation.expiryDate.split("/")[0];
  const expireYear = paymentInformation.expiryDate.split("/")[1];
  try {
    const response = await axios.post("/api/Payment/CreatePayment", {
      orderId: createdOder.OrderId,
      cardHolderName: paymentInformation.cardName,
      cardNumber: paymentInformation.cardNumber,
      expireMonth: expireMonth,
      expireYear: expireYear,
      cvc: paymentInformation.cvc,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
